import BasicLayout from '@components/layout/BasicLayout'
import MusicPlayerSection from '@components/musicPlayer/musicPlayerSection'
import Sentipedia, { SORT_SENTIUS } from '@components/sentius/Sentipedia'
import SentipediaIntro from '@components/sentius/SentipediaIntro'
import getDynasties from '@operations/queries/getDynasties'
import getElements from '@operations/queries/getElements'
import getPage from '@operations/queries/getPage'
import getRarities from '@operations/queries/getRarities'
import getSentius, { getSentiusCount } from '@operations/queries/getSentius'
import getSiteSettings from '@operations/queries/getSiteSettings'
import useMediaQuery, { maxWidthQueries } from '@operations/utils/useMediaQuery'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'

const SentipediaPage = ({
  data: { sentiusList, elementsList, rarityList, page, siteSettings, dynastiesList },
}) => {
  const router = useRouter()
  const isMobile = useMediaQuery(maxWidthQueries.sm)
  const [wasIntroClosed, setWasIntroClosed] = useState(false)
  const [cookiesLoaded, setCookiesLoaded] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setWasIntroClosed(!!window.sessionStorage.getItem('sentipediaIntroClosed'))
      setCookiesLoaded(true)
    }
  }, [])
  return (
    <>
      <BasicLayout
        dynastiesList={dynastiesList}
        footerLinks={siteSettings?.footerLinks}
        footerLogo={siteSettings?.footerLogo?.url}
        headerLinks={siteSettings?.headerLinks}
        headerLogo={siteSettings?.logo?.url}
        hidden={!cookiesLoaded}
        socialLinks={siteSettings?.socialLinks}
      >
        <Sentipedia
          dynastiesList={dynastiesList}
          dynasty={router?.query?.dynasty}
          elementsList={elementsList}
          rarityList={rarityList}
          sentiusList={sentiusList}
          seo={page?.seo}
        />
        <MusicPlayerSection />
      </BasicLayout>
      {!isMobile && !wasIntroClosed && cookiesLoaded && <SentipediaIntro />}
    </>
  )
}

export const getStaticProps = async () => {
  let page
  let sentiusCount
  let sentiusList = []
  let elementsList = []
  let siteSettings
  let rarityList = []
  let dynastiesList = []
  if (process.env.API_URL) {
    sentiusCount = await getSentiusCount()
    sentiusList = await getSentius(`${SORT_SENTIUS}&_limit=${sentiusCount}`)
    elementsList = await getElements()
    rarityList = await getRarities()
    siteSettings = await getSiteSettings()
    page = await getPage('sentipedia')
    dynastiesList = await getDynasties()
  }

  return {
    props: {
      data: {
        dynastiesList: dynastiesList || null,
        elementsList: elementsList || null,
        page: page?.[0] || null,
        rarityList: rarityList || null,
        sentiusList: sentiusList || null,
        siteSettings: siteSettings || null,
      },
    },
    revalidate: false,
  }
}

export default SentipediaPage
